import React, { useState } from "react";
import PropTypes from "prop-types";
import { FormValidation } from "../Validation/FormValidation";
import { TextField } from "@mui/material";

function InputField({
  multiline,
  rows,
  value,
  name,
  errorMsg,
  isRequired,
  label,
  type,
  placeholder,
  validators,
  defaultValue,
  onChange,
  isdisabled,
}) {
  const handleChange = (event) => {
    const { value } = event.target;
    onChange(name, value);
  };

  return (
    <div className="form-group">
      {isdisabled ? (
        <TextField
          disabled
          name={name}
          multiline={multiline}
          fullWidth
          required={isRequired}
          value={value}
          type={type}
          size="small"
          id="outlined-required"
          label={label}
          defaultValue={defaultValue ? defaultValue : null}
          onChange={handleChange}
          onWheel={type === "number" ? (e) => e.target.blur() : undefined}
          error={errorMsg}
          helperText={errorMsg}
        />
      ) : (
        <TextField
          name={name}
          multiline={multiline}
          rows={multiline ? rows : undefined}
          fullWidth
          required={isRequired}
          value={value}
          type={type}
          size="small"
          id="outlined-required"
          label={label}
          defaultValue={defaultValue ? defaultValue : null}
          onChange={handleChange}
          onWheel={type === "number" ? (e) => e.target.blur() : undefined}
          error={errorMsg}
          helperText={errorMsg}
          InputProps={
            multiline
              ? { sx: { fontSize: "0.9rem" } }
              : { sx: { height: 40, fontSize: "0.9rem" } }
          }
        />
      )}
    </div>
  );
}

InputField.propTypes = {
  value: PropTypes.string,
  name: PropTypes.string,
  label: PropTypes.string,
  type: PropTypes.string,
  placeholder: PropTypes.string,
  validators: PropTypes.array,
  onChange: PropTypes.func.isRequired,
  isRequired: PropTypes.bool,
  multiline: PropTypes.bool,
  rows: PropTypes.number,
  isdisabled: PropTypes.bool,
  inputProps: PropTypes.array,
  errorMsg: PropTypes.string,
};

InputField.defaultProps = {
  value: "",
  name: "",
  label: "",
  type: "text",
  placeholder: "",
  validators: [],
  isRequired: false,
  multiline: false,
  rows: 3,
  inputProps: [],
  errorMsg: "",
};

export default InputField;
